import React from 'react';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SectionTitle from './SectionTitle';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ContentTitle from './ContentTitle';
import ServiceButton from './ServiceButton';
import ExternalIcon from '../../../../images/features/local_delivery/external_icon.png';
import LocalDeliveryImage from '../../../../images/features/local_delivery/local-delivery.jpg';
import SanadaSanImage from '../../../../images/features/local_delivery/sanada-san.jpg';
import MoritaSanImage from '../../../../images/features/local_delivery/morita-san.jpg';
import SpaceLogo from '../../../../images/features/local_delivery/space_logo.jpg';
import {
  BACKGROUND_BASE_COLOR,
  BACKGROUND_GRID_COLOR,
  BORDER_COLOR_MORITA_SAN,
  BORDER_COLOR_SANADA_SAN,
  ON_AIR_DATES,
  ON_AIR_ID,
} from '../constants';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import StyledTypography from './StyledTypography';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  background: {
    position: 'absolute',
    backgroundColor: BACKGROUND_BASE_COLOR,
    zIndex: -2,
    width: '100%',
    height: '100%',
  },
  grid: {
    position: 'absolute',
    backgroundImage: `linear-gradient(${BACKGROUND_GRID_COLOR} 1px, transparent 0), linear-gradient(90deg, ${BACKGROUND_GRID_COLOR} 1px, transparent 0)`,
    backgroundSize: '24px 24px',
    zIndex: -1,
    width: '100%',
    height: '100%',
  },
  inner: {
    padding: theme.spacing(8, 2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8, 4),
    },
  },
  contents: {
    backgroundColor: 'white',
    borderRadius: 10,
    maxWidth: theme.breakpoints.values.lg - 100,

    margin: theme.spacing(4, 0),
    padding: theme.spacing(4, 2),
    [theme.breakpoints.up('sm')]: {
      margin: `${theme.spacing(4)}px auto`,
      padding: theme.spacing(8, 6),
    },
  },
  innerContent: {
    display: 'flex',
  },
  leftContent: {
    paddingRight: theme.spacing(2),

    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
  logo: {
    marginBottom: theme.spacing(2),
    width: '80%',
    maxWidth: 300,
    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
  },
  description: {
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(4),
  },
  imageContainer: {
    width: '50%',
  },
  image: {
    width: '100%',
    paddingLeft: theme.spacing(2),
  },
  imageContainerSp: {
    textAlign: 'center',
  },
  imageSp: {
    width: '100%',
    maxWidth: 600,
    padding: theme.spacing(0, 0, 4),
  },
  contentContainer: {
    marginBottom: theme.spacing(4),
  },
  contentTitleContainer: {
    marginBottom: theme.spacing(2),
  },
  performers: {
    textAlign: 'center',
  },
  performer: {
    maxWidth: 128,
    width: '100%',
    height: 'auto',
    marginBottom: theme.spacing(1),
  },
  sanadaSan: {
    border: `4px solid ${BORDER_COLOR_SANADA_SAN}`,
  },
  moritaSan: {
    border: `4px solid ${BORDER_COLOR_MORITA_SAN}`,
  },
  caption: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
  },
  sentenceContainer: {
    marginBottom: theme.spacing(2),
  },
  onAirDateGrid: {
    marginLeft: theme.spacing(1.5),
  },
  bold: {
    fontWeight: 'bold',
  },
  buttons: {
    textAlign: 'center',
  },
  inlineBlock: {
    display: 'inline-block',
  },
  button: {
    width: '100%',
    maxWidth: 420,
    padding: theme.spacing(2, 0),
    [theme.breakpoints.up('md')]: {
      margin: 0,
    },
  },
  externalIcon: {
    width: 15,
  },
  dateWrapper: {
    display: 'flex',
  },
  dateInner: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      marginBottom: theme.spacing(1),
    },
  },
  dateNum: {
    marginRight: theme.spacing(1),
  },
  date0: {
    margin: theme.spacing(0, 1, 0, 0),
    [theme.breakpoints.down('xs')]: {
      margin: 0,
    },
  },
  date1: {
    margin: 0,
  },
}));

const OnAir = () => {
  const classes = useStyles();
  const match = useMediaQuery((theme) => theme.breakpoints.up('md'));
  return (
    <div className={classes.root} id={ON_AIR_ID}>
      <div className={classes.background} />
      <div className={classes.grid} />
      <div className={classes.inner}>
        <SectionTitle title="ONAIR" subtitle="オンエア情報" />
        <div className={classes.contents}>
          <div className={classes.innerContent}>
            <div className={classes.leftContent}>
              <img
                src={SpaceLogo}
                alt="スペースシャワーTVプラス"
                className={classes.logo}
              />
              <StyledTypography className={classes.description}>
                スペースシャワーTVプラスにて、9/19(日)から放送スタートいたします！毎月第3日曜19:00〜よりレギュラー放送いたします。
              </StyledTypography>
              <div className={classes.contentContainer}>
                <div className={classes.contentTitleContainer}>
                  <ContentTitle variant="h3">出演者情報</ContentTitle>
                </div>
                <Grid
                  container
                  spacing={3}
                  className={classes.performers}
                  wrap="nowrap"
                >
                  <Grid item>
                    <img
                      src={SanadaSanImage}
                      alt="真田佑馬さん"
                      className={clsx(classes.performer, classes.sanadaSan)}
                    />
                    <Typography className={classes.caption}>7ORDER</Typography>
                    <Typography className={classes.caption}>
                      真田佑馬さん
                    </Typography>
                  </Grid>
                  <Grid item>
                    <img
                      src={MoritaSanImage}
                      alt="森田美勇人さん"
                      className={clsx(classes.performer, classes.moritaSan)}
                    />
                    <Typography className={classes.caption}>7ORDER</Typography>
                    <Typography className={classes.caption}>
                      森田美勇人さん
                    </Typography>
                  </Grid>
                </Grid>
              </div>
            </div>
            {match && (
              <div className={classes.imageContainer}>
                <img
                  src={LocalDeliveryImage}
                  alt="真田・森田のローカルデリバリー"
                  className={classes.image}
                />
              </div>
            )}
          </div>
          <div className={classes.contentContainer}>
            <div className={classes.contentTitleContainer}>
              <ContentTitle variant="h3">オンエア予定</ContentTitle>
            </div>
            <Grid container className={classes.sentenceContainer}>
              <Grid item xs={12} sm="auto">
                <StyledTypography className={classes.bold}>
                  【放送回数】
                </StyledTypography>
              </Grid>
              <Grid item xs={12} sm="auto">
                <StyledTypography>全７回</StyledTypography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item>
                <StyledTypography className={classes.bold}>
                  【放送日時】
                </StyledTypography>
              </Grid>
              <Grid item>
                <StyledTypography>毎月第3日曜19:00〜19:30</StyledTypography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="column"
              classes={{ root: classes.onAirDateGrid }}
            >
              {ON_AIR_DATES.map((date: Array<string>) => {
                return (
                  <StyledTypography
                    key={date[0]}
                    classes={{ root: classes.inlineBlock }}
                    component="div"
                  >
                    <div className={classes.dateWrapper}>
                      <div className={classes.dateNum}>{date[0]}</div>
                      <div className={classes.dateInner}>
                        <p className={classes.date0}>{date[1]}</p>
                        <p className={classes.date1}>{date[2]}</p>
                      </div>
                    </div>
                  </StyledTypography>
                );
              })}
            </Grid>
          </div>
          {!match && (
            <div className={classes.imageContainerSp}>
              <img
                src={LocalDeliveryImage}
                alt="真田・森田のローカルデリバリー"
                className={classes.imageSp}
              />
            </div>
          )}
          <Grid container spacing={2} className={classes.buttons}>
            <Grid item xs={12} md={6}>
              <ServiceButton
                classes={{ root: classes.button }}
                endIcon={
                  <img
                    src={ExternalIcon}
                    alt=""
                    className={classes.externalIcon}
                  />
                }
                href="http://sstv.jp//localdelivery"
                target="_blank"
                rel="noreferrer"
              >
                スペースシャワーTVプラス
              </ServiceButton>
            </Grid>
            <Grid item xs={12} md={6}>
              <ServiceButton
                classes={{ root: classes.button }}
                endIcon={
                  <img
                    src={ExternalIcon}
                    alt=""
                    className={classes.externalIcon}
                  />
                }
                href="https://www.spaceshowertvplus.com/howto/"
                target="_blank"
                rel="noreferrer"
              >
                視聴方法はこちら
              </ServiceButton>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default OnAir;
